<template>
  <div class="balance">

    <div class="head_balance">
      <img class="head_balancebg" src="/static/img/center_balance.png" alt="">
      <div class="count_balance">
        <p class="money">{{member.credit2}}</p>
        <p class="label">账户余额（元）</p>
      </div>
    </div>

    <div class="withdrawal_box">
      <ul>
        <!-- <li>
          <div class="fl withdrawal_count">入股股金 <span class="">(3000)</span></div>
          <div class="fr flex_center">
            <router-link to="/withdrawal" class="withdrawal_btn">提现</router-link><van-icon size="16" name="arrow" color="#A8AEAC"/>
          </div>
        </li> -->
        <!-- <li>
          <div class="fl">分享券 <span class="">(1000)</span></div>
          <div class="fr"><van-icon size="16" name="arrow" color="#A8AEAC"/></div>
        </li> -->
      </ul>
    </div>

    <div class="balance_detail mb_10" style="padding-bottom:3rem;">
      <p class="balance_detail_label">余额明细</p>
      <ul v-if="member_balance.length > 0">
        <li v-for="(balance,index) in member_balance" :key="index">
          <div class="balance_detail_left fl">
            <p>{{balance.remark_str}}</p>
            <p class="bdl_time">{{balance.createtime_str}}</p>
          </div>
          <div class="balance_detail_right fr">{{balance.num}}</div>
        </li>
      </ul>
      <p class="item_none" v-else >暂无明细</p>
    </div>
    <div style="
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #45B9BC;
    color: #fff;
    font-size: .9rem;
    width: 100%;
    line-height: 2.2rem;
    text-align: center;"><router-link :to="{path:'/recharge',query:{entrance:'balance'}}">充值</router-link></div>

  </div>
</template>

<script>
export default {
  name: "balance",
  components: {},
  data() {
    return {
      member:[],
      member_balance:[]
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_member();
      this.get_member_balance();
    },
    get_member() {
      this.axios({
        url: this.api.member.get_member, 
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member = res.member;
        }
      });
    },
    get_member_balance(){
      this.axios({
        url: this.api.member.get_member_balance, 
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member_balance = res.member_balance;
        }
      });
    }
  }
};
</script>
<style scoped>
.item_none{
  text-align:center;
  font-size:.7rem;
  color:#666;
  padding:.75rem 0;
}
.withdrawal_box{
  font-size:.75rem;
  color:#464646;
  background-color:white;
}
.withdrawal_box li{
  border-bottom:1px solid #eee;
  padding:.75rem .75rem;
  clear:both;
  overflow:hidden;
}
.withdrawal_box li span{
  color:#45B9BC;
  padding-left:.2rem;
}
.withdrawal_btn{
  border:1px solid #45B9BC;
  padding:.1rem .7rem;
  border-radius:5px;
  color:#45B9BC;
}
.withdrawal_count{
  line-height:1.3rem;
}
.head_balance{
  position:relative;
}
.count_balance{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    margin-top: 13%;
    font-size: 0.9rem;
    color: #f2f2f2;
}
.money{
  font-size:1.5rem;
  color:#F2F2F2;
}
.label{
  margin-top:.1rem;
  font-size:.6rem;
  color:#F2F2F2;
}
.balance_detail_label{
  font-size:.75rem;
  color:#767979;
  padding:.75rem;
  background-color:#F4F5F6;
}
.balance_detail{
  background-color:white;
}
.balance_detail li{
  font-size:.75rem;
  color:#767979;
  clear:both;
  overflow:hidden;
  padding:.75rem;
  border-bottom:1px solid #eee;
}
.bdl_time{
  font-size:.6rem;
  color:#AAADAD;
}
</style>



// WEBPACK FOOTER //
// src/views/center/balance.vue